export default __webpack_public_path__ + "static/media/fasting_window@3x.1729dcff.jpg";